import useUpdateEffect from '@/common/hook/updateEffect/useUpdateEffect';
import { FC, useMemo, useRef } from 'react';
import { Typography } from 'antd';
import styles from '../index.module.less';
import { showMarker } from '@/common/utils/map';
import IconFont from '@/common/components/IconFont';
import { targetLegendIcon } from '../../../ts-config';
import { mapContainer } from '..';
import { isNotEmpty, isArray } from '@lhb/func';
const { Paragraph } = Typography;
import { v4 } from 'uuid';
import AmapRailOfBC from '@/common/components/business/AmapRailOfBC';
/**
 * @Description 周边配套
 */
const CommonRimMarker:FC<{
  mapIns: any,
  mapDom: any;
  data: any,
  contentMarkerRef: any,
  curDetail: any,
  setCurDetail: any,
  curZoom: number; // 地图zoom
  curBounds: any; // 可视范围
  handleDetailToNull: any,
  onClickMarker?: () => void,
}> = ({
  mapIns,
  mapDom,
  data,
  contentMarkerRef,
  curDetail,
  setCurDetail,
  curZoom,
  curBounds,
  handleDetailToNull,
  onClickMarker = () => {}
}) => {
  const massListRef = useRef<any>([]);
  const activeMarker = useRef<any>(null);
  const activePolygon = useRef<any>(null);

  const dragPixelRef = useRef<any>(null); // marker 拖拽时pixel的缓存

  // 商业和其他的的数据格式不一样，统一成相同的格式
  const targetFormattingData = useMemo(() => {
    const targetData: any = Object.values?.(data)?.find?.((item) => isArray(item) && item.length > 0);
    // if (targetData?.[0]?.isCommercial || targetData?.[0]?.isCommunity) {
    // 商业
    if (targetData?.[0]?.isCommercial) {
      return targetData.map((item: any) => {
        item.uid = v4();
        const { polygon } = item || {};
        if (isArray(polygon) && polygon.length) {
          item.usablePolygon = polygon;
        }
        return item;
      });
    }
    // 其他
    if (isArray(targetData) && targetData.length) {
      return targetData.map((item: any) => {
        item.uid = v4();
        const { polygonList } = item || {};
        if (isArray(polygonList) && polygonList.length) {
          const targetPolygon = polygonList.filter(item => +item.lng && +item.lat).map(item => [Number(item.lng), Number(item.lat)]);
          item.usablePolygon = targetPolygon;
        }
        return item;
      });
    }
    return [];
  }, [data]);

  const createContentMarker = (value, tag, activeMarker = null) => {
    const dom = document.querySelector(`.${mapContainer}`);
    var pixel = mapIns.lngLatToContainer([value?.lng, value?.lat]);
    const { x, y } = pixel;
    const offset = [0, 0];
    let topBottom = 'top';
    let leftRight = 'center';
    if (y < 200) {
      topBottom = 'top';
    } else if ((dom?.clientHeight || 0) - y < 200) {
      topBottom = 'bottom';
      offset[1] = 0;
    }
    if (x < 200) {
      leftRight = 'left';
    } else if ((dom?.clientWidth || 0) - x < 200) {
      leftRight = 'right';
    }

    contentMarkerRef.current && mapIns.remove(contentMarkerRef.current);
    contentMarkerRef.current = new window.AMap.Marker({
      position: [value.lng, value.lat],
      anchor: `${topBottom}-${leftRight}`,
      offset,
      zIndex: 60,
      extData: {
        tag
      },
      draggable: true, // 主动设置可拖拽，但是在拖拽的时候不执行来达到拖拽时卡片抖动的场景
    });
    setTimeout(() => {
      contentMarkerRef.current?.on?.('dragstart', (e) => {
        dragPixelRef.current = new window.AMap.Pixel(e.target._points[0] - e.pixel.x, e.target._points[1] - e.pixel.y);
        contentMarkerRef.current.setOffset(dragPixelRef.current);
      });
      contentMarkerRef.current?.on?.('dragend', (e) => {
        const markerLeftTop = [dragPixelRef.current.x + e.pixel.x, dragPixelRef.current.y + e.pixel.y];
        // 转换为经纬度坐标
        const lnglat = mapIns.containerToLngLat(new window.AMap.Pixel(markerLeftTop[0], markerLeftTop[1]));
        contentMarkerRef.current.setOffset(new window.AMap.Pixel(0, 0));
        contentMarkerRef.current.setPosition(lnglat);
      });
    }, 100);
    mapIns.add(contentMarkerRef.current);
    onClickMarker?.();
    showMarker(contentMarkerRef.current,
      <TargetBrand
        data={value}
        mapIns={mapIns}
        marker={contentMarkerRef.current}
        activeMarker={activeMarker}
        handleDetailToNull={() => {
          activePolygon.current && mapIns.remove(activePolygon.current);
          handleDetailToNull();
        }}
        tag={tag}
      />);
  };
  const createMass = (data, key) => {
    const value = data.map((item) => ({
      lnglat: [+item.lng, +item.lat],
      detail: item,
      ...item,
    }));

    var mass = new window.AMap.MassMarks(value, {
      opacity: 1,
      cursor: 'pointer',
      style: {
        url: `${targetLegendIcon?.[key]}`,
        size: [24, 29],
        anchor: 'bottom-center'
      },
      zooms: [1, 20],
      zIndex: 500, // 不然会被showIndoorMap遮挡
    });
    mass.setMap(mapIns);

    mass.on('click', ({ data }) => {
      handleDetailToNull();
      setCurDetail(data);
      // 动态改变 Marker 的图标和尺寸
      activeMarker.current && mapIns.remove(activeMarker.current);
      createActiveMarker(data, key);
      createActivePolygonMarker(data);
    });
    massListRef.current.push(mass);
  };
  const createActiveMarker = (value, key) => {
    const marker = new window.AMap.Marker({
      position: [value.lng, value.lat],
      content: `<img class="storeMarkerActive" src="${targetLegendIcon?.[key]}"/>`,
      anchor: 'bottom-center',
      extData: value
    });
    activeMarker.current && mapIns.remove(activeMarker.current);
    activeMarker.current = marker;
    createContentMarker(value, key, marker);
    mapIns.add(marker);
  };
  const createActivePolygonMarker = (value) => {
    activePolygon.current && mapIns.remove(activePolygon.current);
    const { polygonList, polygon, isCommercial } = value || {};
    // 当是商业时,必须有polygon才能绘制 || 非商业时，必须有polygonList才能绘制
    if (isCommercial && !value?.polygon?.length || (!isCommercial && !value?.polygonList?.length)) {
      return;
    }
    const polygonMarker = new window.AMap.Polygon({
      path: isCommercial ? polygon : polygonList.map((item: any) => [+item?.lng, +item?.lat]),
      fillColor: '#006AFF',
      strokeOpacity: 1,
      fillOpacity: 0.2,
      strokeColor: '#4792FD',
      strokeWeight: 2,
    });

    activePolygon.current = polygonMarker;
    mapIns.add(polygonMarker);
  };
  const clearMarker = () => {
    massListRef.current?.map((mass) => {
      mass?.clear();
    });
    massListRef.current = [];
    activeMarker.current && mapIns?.remove(activeMarker.current);
    activePolygon.current && mapIns.remove(activePolygon.current);
  };
  useUpdateEffect(() => {
    if (!mapIns) return;
    clearMarker();
    Object.keys(data)?.map((item) => {
      createMass(data[item], item);
      // data[item].map((value) => {
      //   createMarker(value, item);
      // });
    });
  }, [mapIns, data]);

  useUpdateEffect(() => {
    let curValue;
    activeMarker.current && mapIns.remove(activeMarker.current);
    activePolygon.current && mapIns.remove(activePolygon.current);
    Object.keys(data).reduce((acc, key) => {
      if (acc) return acc;
      data[key].map((item) => {
        if (item.lng === curDetail?.lng && item.lat === curDetail?.lat) {
          acc = true;
          curValue = {
            ...item,
            tag: key
          };
        };
      });
      return acc;
    }, false);

    if (curValue) {
      createContentMarker(curValue, curValue.tag);
      createActiveMarker(curValue, curValue.tag);
      createActivePolygonMarker(curValue);
    }
  }, [curDetail]);

  useUpdateEffect(() => {
    const tag = contentMarkerRef.current?.getExtData()?.tag;
    if (tag && !data[tag]?.length) {
      contentMarkerRef.current && mapIns?.remove(contentMarkerRef.current);
    }
  }, [data]);

  return <div>
    {/* 类型为 商业 || 小区时需要展示围栏 */}
    {/* {
      targetFormattingData?.[0]?.isCommercial || targetFormattingData?.[0]?.isCommunity ? <AmapRailOfBC
        data={targetFormattingData}
        mapIns={mapIns}
        curZoom={curZoom}
        curBounds={curBounds}
      /> : <></>
    } */}
    <AmapRailOfBC
      data={targetFormattingData}
      mapIns={mapIns}
      curZoom={curZoom}
      curBounds={curBounds}
      mapDom={mapDom}
    />
  </div>;
};

const TargetBrand = ({
  data,
  mapIns,
  marker,
  activeMarker,
  handleDetailToNull,
  tag
}) => {
  const showText = tag === 'ZHU_ZHAI'; // 小区类型展示房价等字段
  const showBusinessText = tag === 'GOU_WU'; // 图例是商业类型时
  const isWork = tag === 'BAN_GONG';
  return <div className={styles.competitorOverview}>
    <IconFont
      iconHref={'iconic_close_colour_seven'}
      className={styles.closeIcon}
      onClick={() => {
        handleDetailToNull();
        mapIns.remove(marker);
        mapIns.remove(activeMarker);
      }}
    />
    {/* <div className='fs-14 bold pr-16'>{data?.name}</div> */}
    <Paragraph
      style={{ width: 170, marginBottom: 0 }}
      ellipsis={{
        tooltip: data?.name,
        rows: 2,
      }}>
      <span className='fs-14 bold pr-16'>
        {data?.name}
      </span>
    </Paragraph>
    {showText
      ? <div className={styles.poiInfo}>
        {data.housePrice
          ? <div className={styles.poiLabel}>参考房价
            <span className={styles.poiValue}>{data.housePrice}</span>
          </div> : ''}
        {data.liveNum ? <div className={styles.poiLabel}>居住人口
          <span className={styles.poiValue}>{data.liveNum || '-'}</span>
        </div> : ''}
        {data.houseHolds ? <div className={styles.poiLabel}>户数
          <span className={styles.poiValue}>{data.houseHolds || '-'}</span>
        </div> : ''}
        {/* {isNotEmpty(data.weightedHomeNumber)
          ? <div className={styles.poiLabel}>加权户数
            <span className={styles.poiValue}>{data.weightedHomeNumber}</span>
          </div> : ''} */}
        {data.buildTime
          ? <div className={styles.poiLabel}>建筑年份
            <span className={styles.poiValue}>{data.buildTime}</span>
          </div> : ''}
        {
          data?.address ? <div className={styles.poiLabel}>地址
            <span className={styles.poiValue}>{data.address}</span>
          </div> : <></>
        }
      </div> : <>
        {
          isWork && isNotEmpty(data?.workNum) ? <div className={styles.poiInfo}>
            <div className={styles.poiLabel}>
              办公人数<span className={styles.poiValue}>{data.workNum}</span>
            </div>
          </div> : <></>
        }
        {
          showBusinessText && <div className={styles.poiInfo}>
            <div className={styles.poiLabel}>开业时间：
              <span className={styles.poiValue}>{data.openingTime || '-'}</span>
            </div>
            <div className={styles.poiLabel}>商业建筑面积：
              <span className={styles.poiValue}>{data.commercialVolume || '-'}㎡</span>
            </div>
            <div className={styles.poiLabel}>地址：
              <span className={styles.poiValue}>{data?.address || '-'}</span>
            </div>
          </div>
        }
        {
          !showBusinessText && data?.address ? <div className='c-999 fs-12 mt-6'>
            {data?.address}
          </div> : <></>
        }
      </>}
  </div>;
};
export default CommonRimMarker;
